const defaultState = () => ({
    show: false,
    data: {},
    time: 0,
});

const mutations = {
    setMaintenanceData(state, data) {
        Object.assign(state, data);
    },
    resetMaintenanceData(state) {
        Object.keys(state).forEach(key => {
            state[key] = key === 'show' ? false : {};
        });
    },
};

const actions = {
    setMaintenanceData({ commit }, data) {
        commit('setMaintenanceData', data);
    },
    resetMaintenanceData({ commit }) {
        commit('resetMaintenanceData');
    },
};

const getters = {
    maintenanceData: state => state,
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
